import { Header } from 'antd/lib/layout/layout'
import TelusLogo from 'src/assets/images/telus_logo.png'
import classes from './Header.module.less'
import { UserProfile } from '../UserProfile/UserProfile'
import { useUserProfile } from 'shared/auth/hooks/use-user-profile/useUserProfile'

export type HeaderCompProps = {
    children?: React.ReactElement
}

const HeaderComp: React.FC<HeaderCompProps> = (props: HeaderCompProps) => {
    const { userProfile } = useUserProfile()

    return (
        <Header className={classes.topBar} data-testid="header-wrapper">
            <div className={classes.logoContainer} data-testid="logo-wrapper">
                <img src={TelusLogo} alt="Telus International Logo" className="logo" />
            </div>
            {!props.children ? (
                <div className={classes.topbarRight} data-testid="children-wrapper">
                    <UserProfile
                        userId={userProfile.user.user_id}
                        userName={userProfile.user.first_name + ' ' + userProfile.user.last_name}
                        userEmail={userProfile.user.email}
                    />
                </div>
            ) : (
                props.children
            )}
        </Header>
    )
}

export default HeaderComp
